<footer class="container-wrapper mt-md-3 selenium-app-footer w-100" id="footer">
    <div
        [ngClass]="{
            'student-container': userService.hasStudentExperience(),
            'teacher-container pt-1 pb-5': !userService.hasStudentExperience()
        }"
        class="container"
    >
        <div
            [ngClass]="
                userService.hasStudentExperience()
                    ? 'justify-content-xs-center justify-content-md-between'
                    : 'ml-0 flex-column justify-content-xs-between justify-content-md-center'
            "
            class="row mx-xs-0 flex-lg-nowrap flex-lg-row justify-content-xs-center justify-content-lg-between mt-xs-7 mt-sm-8"
        >
            <div
                [ngClass]="
                    userService.hasStudentExperience()
                        ? 'col-md-6 align-items-xs-center'
                        : 'col-md-4 col-sm-6 col-lg-4 align-items-sm-start'
                "
                class="mobile-top-section d-flex flex-column flex-nowrap align-items-xs-center align-items-md-start"
            >
                <div
                    *ngIf="!userService.hasStudentExperience()"
                    class="student-view-button px-0 py-0 text-center d-xs-inline-block"
                >
                    <a
                        aria-label="Access student site"
                        class="{{
                            gtmPrefix + 'student-button ' + 'btn'
                        }} d-flex align-items-center font-weight-bold text-white"
                        (click)="changeUserExperience(true)"
                        rel="noopener noreferrer"
                        role="button"
                        target="_blank"
                    >
                        Student Site
                    </a>
                </div>
                <div class="in-partnership mt-6">In partnership with</div>
                <div
                    class="logos d-inline-block position-relative flex-column d-md-grid align-middle align-items-center mb-2 justify-content-between"
                >
                    <span
                        [attr.data-gtmlabel]="'PBS'"
                        class="{{ gtmPrefix + 'logo-pbs ' + 'logo-pbs' }} mt-1 h-100 mr-6 my-0"
                        rel="noopener noreferrer"
                        [ngClass]="userService.hasStudentExperience() ? '' : 'mb-4'"
                    >
                        <img
                            [src]="pbsLogoWhite"
                            alt="PBS LearningMedia"
                            [ngClass]="userService.hasStudentExperience() ? '' : 'mr-6'"
                        />
                    </span>
                    <span
                        [attr.data-gtmlabel]="'WGBH'"
                        class="{{ gtmPrefix + 'logo-wgbh ' + 'logo-wgbh' }} mx-lg-1 my-0"
                    >
                        <img
                            alt="WGBH logo"
                            src="https://d43fweuh3sg51.cloudfront.net/defaults/wgbh-logo.svg"
                        />
                    </span>
                </div>
                <div
                    *ngIf="userService.hasStudentExperience()"
                    class="rights-reserved-student pb-6 text-xs-center text-md-left"
                >
                    &copy; {{ currentYear }} PBS &amp; GBH Educational Foundation. All rights
                    reserved.
                </div>
            </div>
            <div
                *ngIf="!userService.hasStudentExperience()"
                class="col-sm-6 col-lg-4 connect-with-us"
            >
                <section class="social-media">
                    <div class="social-media__inner py-0 px-0 my-0 mx-auto">
                        <h3 class="footer-title text-uppercase">Connect With Us</h3>
                        <p class="sign-up-for mx-xs-0 mt-xs-4 mb-xs-3 mb-lg-5">
                            Sign up for our newsletter for the latest resources, news, and more.
                        </p>
                        <div class="input-group mb-xs-6">
                            <input
                                class="form-control input-email rounded-0 text-white"
                                id="email-eloqua-newsletter"
                                placeholder="Your email"
                                required
                                title="Please enter a valid email address."
                                type="email"
                            />
                            <span class="input-group-btn input-group-append font-weight-bold">
                                <span
                                    (click)="subscribe()"
                                    [attr.data-gtmlabel]="'Go'"
                                    class="{{
                                        gtmPrefix +
                                            'newsletter-go ' +
                                            'input-group-text btn btn-success text-white px-3 py-0'
                                    }} font-weight-bold"
                                    id="eloqua-newsletter-go"
                                    >Sign up!</span
                                >
                            </span>
                        </div>
                        <a
                            class="social-media__link text-decoration-none d-inline-block overflow-hidden mr-3"
                            href="https://www.facebook.com/pbsteachers"
                            rel="noopener noreferrer"
                            target="_blank"
                            ><i class="fab fa-facebook-f mx-0 my-0 pl-10 pt-10 text-white"></i
                            >Facebook</a
                        >
                        <a
                            class="social-media__link text-decoration-none d-inline-block overflow-hidden mr-3"
                            href="https://twitter.com/pbsteachers"
                            rel="noopener noreferrer"
                            target="_blank"
                            ><i class="fab fa-twitter mx-0 my-0 pl-10 pt-10 text-white"></i
                            >Twitter</a
                        >
                        <a
                            class="social-media__link text-decoration-none d-inline-block overflow-hidden mr-3"
                            href="https://www.pinterest.com/pbslm/"
                            rel="noopener noreferrer"
                            target="_blank"
                            ><i class="fab fa-pinterest mx-0 my-0 pl-10 pt-10 text-white"></i
                            >Pinterest</a
                        >
                    </div>
                </section>
            </div>
            <div *ngIf="!userService.hasStudentExperience()" class="learn-more">
                <h3 class="footer-title text-uppercase">Learn More</h3>
                <ul class="list-unstyled py-0 px-0">
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            [attr.data-gtmlabel]="'PBS Education'"
                            class="{{ gtmPrefix + 'pbs-education' }} text-white"
                            href="https://www.pbs.org/education/"
                            rel="noopener noreferrer"
                            target="_blank"
                            >PBS Education</a
                        >
                    </li>
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            (click)="openFeedbackForm($event)"
                            class="my-0 text-white"
                            href="#"
                            role="button"
                            >Contact Us</a
                        >
                    </li>
                    <li class="secondary-nav__item px-0 py-0 border-0 mb-1">
                        <a
                            [attr.data-gtmlabel]="'Help'"
                            class="{{ gtmPrefix + 'help' }} text-white"
                            href="/help/"
                            >Help</a
                        >
                    </li>
                </ul>
            </div>
            <div
                *ngIf="userService.hasStudentExperience()"
                [ngClass]="{ 'logged-in-user': userService.isLoggedIn() }"
                class="student-right-side justify-content-end d-flex flex-column justify-content-end align-middle align-items-center flex-nowrap"
            >
                <button
                    (click)="teacherLogin()"
                    *ngIf="!userService.isLoggedIn()"
                    class="btn btn-primary mb-6 font-weight-bold"
                >
                    Teachers, sign in for resources
                </button>
                <button
                    *ngIf="userService.isLoggedIn() && !userService.isStudent()"
                    class="btn btn-primary mb-6 font-weight-bold"
                    (click)="changeUserExperience(false)"
                >
                    Return to Teacher view
                </button>
                <div class="terms-and-privacy-policy">
                    <app-link
                        [appRouterLink]="'/help/privacy-policy/'"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        target="_blank"
                        >Privacy Policy</app-link
                    >
                    <app-link
                        [appRouterLink]="'/help/terms-of-use/'"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        target="_blank"
                        >Terms of Use</app-link
                    >
                    <app-link
                        [appRouterLink]="'/help/'"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        target="_blank"
                        >Help</app-link
                    >
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!userService.hasStudentExperience()" class="copyright-wrapper">
        <div class="legal-and-contact py-4 px-0 text-center w-100">
            <div class="col-12">
                <div class="rights-reserved d-inline-block">
                    &copy; {{ currentYear }} PBS &amp; GBH Educational Foundation. All rights
                    reserved.
                </div>
                <div class="terms-and-privacy-policy d-inline-block">
                    <app-link
                        [appRouterLink]="'/help/privacy-policy/'"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        target="_blank"
                        >Privacy Policy</app-link
                    >
                    <span>|</span>
                    <app-link
                        [appRouterLink]="'/help/terms-of-use/'"
                        [attr.data-gtmlabel]="'Help'"
                        class="{{ gtmPrefix + 'help' }} my-2 mx-3"
                        target="_blank"
                        >Terms of Use</app-link
                    >
                </div>
            </div>
        </div>
    </div>
    <div
        aria-hidden="true"
        aria-labelledby="myModalLabel"
        class="modal fade"
        id="feedbackModal"
        role="dialog"
    >
        <div class="modal-dialog">
            <div class="modal-content"></div>
        </div>
    </div>
</footer>
